import React from "react";

const ClearButton = ({ text = "Clear" , onClick }) =>{
    return <span style={{
        cursor: "pointer"
    }} onClick={onClick}><i className="fa fa-close"/> {text}</span>
};

export default ClearButton;


// WEBPACK FOOTER //
// ./src/components/CRUDView/Components/ClearButton.js